<template>
  <div id="wrapper">
    <TextHeader header-title="404"/>
    <div class="w-container">
      <h4>Ne pare rău dar pagina căutată nu a putut fi găsită!</h4>
    </div>
  </div>
</template>

<script>
    import TextHeader from "./TextHeader";

    export default {
        name: "P404",
        components: {TextHeader}
    }
</script>

<style scoped>
  #wrapper {
    min-height: 80vh;
  }
</style>
